export default "__VITE_ASSET__DGt5yBeV__"